module.exports = __webpack_public_path__ + "static/img/05.b98b5d26.jpg";